import React from "react";
import { InputGroup, Form } from "react-bootstrap";

interface SearchBarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  disabled?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  searchTerm,
  onSearchChange,
  onClear,
  placeholder = "Buscar por nombre, documento o ficha...",
  disabled = false,
}) => {
  return (
    <InputGroup style={{ maxWidth: "400px" }}>
      <Form.Control
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => onSearchChange(e.target.value)}
        className="form-control-sm"
        disabled={disabled}
      />
      {searchTerm && (
        <button
          className="btn btn-danger btn-sm"
          type="button"
          onClick={onClear}
          title="Limpiar búsqueda"
          disabled={disabled}
        >
          <i className="mdi mdi-close" />
        </button>
      )}
    </InputGroup>
  );
};
